/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LogisticsGroupModel>>;
export function request(
  body: defs.basics.LogisticsGroupRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroup/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
